import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { UpdateMeetingInput } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const UpdateMeetingMutation = graphql(`
  mutation UpdateMeeting($input: UpdateMeetingInput!) {
    updateMeeting(input: $input) {
      id
      scheduledDate
      scheduledStartTime
      scheduledEndTime
      occurrenceDate
      series {
        id
        __typename
        cadence
        startDate
        until
        scheduledStartTime
        scheduledEndTime
      }
      __typename
      client {
        id
        legacyId
        name
        externalReference
        __typename
      }
    }
  }
`);

export function useUpdateMeeting() {
  const [result, updateMeetingMutation] = useMutation(UpdateMeetingMutation);
  const [error, setError] = useState<Error | null>(null);

  const updateMeeting = useCallback(
    async (input: UpdateMeetingInput) => {
      try {
        const response = await updateMeetingMutation({ input });
        if (response.error) {
          throw response.error;
        }
        return response.data?.updateMeeting;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [updateMeetingMutation],
  );

  return { updateMeeting, result, error };
}
